var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-4",attrs:{"elevation":"2","rounded":"0"}},[_c('v-card-title',[_vm._t("title")],2),_c('v-card-text',[_vm._t("items")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }